import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmailIcon from 'mdi-react/EmailIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import './stylevn.css';

function FooterEn() {

    return (
        <div id="footer">
            <div class="footer-top">
                <div class="fit-block footer-body container">
                    <div class="row">
                        <div class="logo-footer">
                            <div class="MuiBox-root css-0">
                                <div class="logo-footer-detail MuiBox-root css-0"><img class="logo-footer-img"
                                    src="https://hanbiro.com/cloud/library/cloudconsult/logo-footer.svg"
                                    alt="imagecloud" />
                                    <p class="typography-message">· Headquarters: Floors 4 and 5, No. 9 Nambusunhwan-ro 333-gil, Seocho-gu, Seoul (Hyochon Building, Seocho-dong) |
                                        Floors 4 and 5, Hyochon Building, 1425-10, Seocho 1-dong, Seocho-gu, Seoul<br />
                                        · USA: 711 S. Vermont Ave., Ste 209, Los Angeles, CA 90005<br />
                                        · China: Room 1108G, 11th Floor, Building A, Tianli Central Business Plaza, Houhai Avenue East, Nanshan District, Shenzhen<br />
                                        · Vietnam: Lot A4a, Street 19C, E-Office Hi-Tech Park, Tan Thuan Dong Ward, District 7, Ho Chi Minh City, Vietnam<br />
                                        · Server Operations Room: 2nd Floor, KIDC Seocho 1 Center, 1423-1 Seocho-dong, Seocho-gu, Seoul<br />
                                        <EmailIcon className="icon-text" />
                                        <a href="mailto:hanbiro@hanbiro.com"
                                            class="text-color text-pur-color">hanbiro@hanbiro.com</a>
                                        &nbsp;&nbsp;&nbsp;
                                        <PhoneIcon className="icon-text" />
                                        Phone: <a href="tel:1800 6346" class="text-color text-pur-color">1800
                                            6346</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div>
                <div class="footer-bottom">
                    <div class="fit-block">
                        <p>All Right Reserved © Hanbiro, Inc.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterEn;
